/* eslint-disable */
// Generated by GitHub Copilot
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { FaUsers, FaUser, FaEnvelope } from "react-icons/fa6";
import "./InterestedPartiesViewer.css";

function InterestedPartiesViewer(props) {
  const interestedParties = props.interestedParties || [];

  // Handle empty state
  if (!interestedParties || interestedParties.length === 0) {
    return (
      <Container>
        <Row>
          <Col>
            <Card className="text-center">
              <Card.Body>
                <FaUsers className="mb-2 text-muted" size={24} />
                <Card.Text className="text-muted">
                  No interested parties have been added.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container>
      <Row>
        <Col>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span className="text-muted">
              {interestedParties.length} interested part
              {interestedParties.length !== 1 ? "ies" : "y"}
            </span>
          </div>
        </Col>
      </Row>

      {interestedParties.map((party, index) => {
        // Generated by GitHub Copilot
        // Handle both old format (string) and new format (object with name/email)
        const displayName =
          typeof party === "string" ? party : party.name || party.email;
        const displayEmail = typeof party === "string" ? party : party.email;

        return (
          <Row key={`interested-party-${index}`} className="mb-2">
            <Col>
              <Card className="interested-party-card">
                <Card.Body className="py-2">
                  <Row className="align-items-center">
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <div className="d-flex align-items-center">
                        <Badge bg="primary" className="me-2">
                          <FaUser className="me-1" />
                          IP
                        </Badge>
                        <div className="flex-grow-1">
                          <div className="fw-bold">{displayName}</div>
                          <div className="text-muted small">
                            <FaEnvelope className="me-1" />
                            {displayEmail}
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        );
      })}
    </Container>
  );
}

export default InterestedPartiesViewer;
